import { defineNuxtPlugin, useRequestEvent, useRuntimeConfig, useState } from "#imports";
export default defineNuxtPlugin({
  name: "nuxt-site-config:init",
  enforce: "pre",
  async setup(nuxtApp) {
    const state = useState("site-config");
    if (process.server) {
      const { context } = useRequestEvent();
      nuxtApp.hooks.hook("app:rendered", () => {
        state.value = context.siteConfig.get({
          debug: useRuntimeConfig()["nuxt-site-config"].debug,
          resolveRefs: true
        });
      });
    }
    let stack = {};
    if (process.client)
      stack = state.value || window.__NUXT_SITE_CONFIG__;
    return {
      provide: {
        nuxtSiteConfig: stack
      }
    };
  }
});
